import { Grid, TextField } from '@mui/material';
import styled from 'styled-components';

import CommonComponentStyle from 'commons/styles/basic-components.styles';
import { LIGHT_GRAY, PRIMARY_GRAY, PRIMARY_RED } from 'commons/styles/colors';

class STOListPageStyle extends CommonComponentStyle {
  SubtitleWrapper = styled(Grid)`
    padding: 8px 0 16px 0;
  `;

  Subtitle = styled(Grid)`
    font-size: 14px;
    font-weight: 700;
  `;

  ErrorMessage = styled(Grid)`
    font-size: 14px;
    font-weight: 700;
    padding-bottom: 8px;
    color: ${this.colors.PRIMARY_RED};
  `;

  SKUGridWrapper = styled(Grid)`
    background: ${this.colors.LIGHTER_GRAY};
    padding: 8px 0;
  `;

  SKUGrid = styled(Grid)`
    font-size: 14px;
    padding-top: 8px;

    &.bold {
      font-weight: 700;
    }
  `;

  SKUButtonGrid = styled(Grid)`
    text-align: right;
  `;

  TableInfoGridWrapper = styled(Grid)`
    border-bottom: 1px solid rgba(0, 0, 0, 0.25);
  `;

  TableInfoGrid = styled(Grid)`
    padding: 8px 0 0 0;

    &.error-message {
      color: ${PRIMARY_RED};
      font-size: 14px;
      display: inline-flex;
    }
    &.no-pad-top {
      padding-top: 0;
      padding-bottom: 16px;
    }
  `;

  ProgressSpan = styled.span`
    color: ${this.colors.PRIMARY_GRAY};
    margin-left: 8px;
  `;

  SearchBar = styled(TextField)`
    width: 100%;
    margin-bottom: 8px !important;
  `;

  STONumberText = styled.span`
    border-radius: 8px;
    font-size: 10px;
    background: ${LIGHT_GRAY};
    color: ${PRIMARY_GRAY};
    padding: 6px;
  `;
}

export default new STOListPageStyle();
